export function getPaymentStatusText(statusPayment?: string): string {
  switch (String(statusPayment || '').toUpperCase()) {
    case 'PAID':
      return 'PAGO';
    case 'NOT_PAID':
      return 'PENDENTE';
    case 'PENDING':
      return 'AGUARDANDO PAGAMENTO';
    case 'CREATING':
      return 'GERANDO PAGAMENTO';
    case 'FAILED':
      return 'FALHOU';
    case 'EXPIRED':
      return 'EXPIRADO';
    case 'CANCELED':
      return 'CANCELADO';
    case 'REFUNDED':
      return 'ESTORNADO';
    default:
      return 'NAO GERADO';
  }
}

export function getPaymentStatusDescription(statusPayment?: string): string {
  switch (String(statusPayment || '').toUpperCase()) {
    case 'PENDING':
      return 'Aguardando confirmacao do pagamento.';
    case 'CREATING':
      return 'Pagamento em criacao.';
    case 'FAILED':
      return 'Pagamento falhou ou foi recusado.';
    case 'EXPIRED':
      return 'Pagamento expirado.';
    case 'CANCELED':
      return 'Pagamento cancelado.';
    case 'REFUNDED':
      return 'Pagamento estornado.';
    default:
      return '';
  }
}
